import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { amplifyConfig } from './config/amplify';
import { AuthProvider } from './context/AuthContext';
import App from './App';
import 'leaflet/dist/leaflet.css';
import './styles/index.css';

// Always configure Amplify. If env vars are missing, it handles it gracefully.
Amplify.configure(amplifyConfig);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
